import { supabase } from '@/src/lib/supabase'
import type { Session } from '@supabase/supabase-js'

/** Ruta de acceso del equipo al panel /admin. */
export const LOGIN_PATH = '/login'

/** Admin del sitio: is_admin() únicamente. No hay más roles (el portal de clientes se retiró el 24/10/2026). */
export async function isStaffSession(session: Session | null): Promise<boolean> {
  if (!session?.user) return false
  const { data, error } = await supabase.rpc('is_admin' as never)
  if (error) {
    console.error('is_admin rpc error', error)
    return false
  }
  return data === true
}

/** Destino tras el login: la ruta del panel que se pidió o el resumen. */
export function getPostLoginPath(from?: string): string {
  return from?.startsWith('/admin') ? from : '/admin'
}
